import { useState, useEffect } from 'react';

/**
 * Hook para autenticação global baseada em localStorage.
 * Espera que o token e os dados do usuário estejam salvos após o login.
 * Exemplo de armazenamento esperado:
 *   localStorage.setItem('token', ...)
 *   localStorage.setItem('user', JSON.stringify({ nome: 'Fulano', ... }))
 */
export default function useAuth() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem('auth_token');
      if (token) {
        try {
          const base64Url = token.split('.')[1];
          const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
          const jsonPayload = decodeURIComponent(
            atob(base64)
              .split('')
              .map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
              })
              .join('')
          );
          const payload = JSON.parse(jsonPayload);
          setUser(payload);
          setIsLoggedIn(true);
        } catch (e) {
          setUser(null);
          setIsLoggedIn(false);
        }
      } else {
        setUser(null);
        setIsLoggedIn(false);
      }
    };

    checkAuth();
    window.addEventListener('focus', checkAuth);
    window.addEventListener('storage', checkAuth);
    return () => {
      window.removeEventListener('focus', checkAuth);
      window.removeEventListener('storage', checkAuth);
    };
  }, []);

  // Para logout
  const logout = () => {
    try { localStorage.removeItem('auth_token'); } catch {}
    try { localStorage.removeItem('user_data'); } catch {}

    // Revoga sessão do Google se disponível (evita reuso do token de identidade)
    try {
      const storedUser = localStorage.getItem('user_data');
      const email = storedUser ? JSON.parse(storedUser)?.email : null;
      if (email && window.google?.accounts?.id?.revoke) {
        window.google.accounts.id.revoke(email, () => {});
      }
    } catch {}

    setUser(null);
    setIsLoggedIn(false);
  };

  return {
    isLoggedIn,
    user,
    logout
  };
}